import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";

function Electricity(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '0px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2 style={{whiteSpace:'normal'}}>Electricity and Circuitry</h2>
                <li>
                    <Link to={`${url}/basics`}>Basics of Circuitry</Link>
                </li>
                <li>
                    <Link to={`${url}/resistance`}>Resistance</Link>
                </li>
                <li>
                    <Link to={`${url}/capacitance`}>Capacitance</Link>
                </li> 
                <li>
                    <Link to={`${url}/inductance`}>Inductance</Link>
                </li> 
                <li>
                    <Link to={`${url}/grounds`}>Grounds</Link>
                </li>
                <li>
                    <Link to={`${url}/ac`}>AC Circuits</Link>
                </li> 
                <li>
                    <Link to={`${url}/threephase`}>Three Phase Systems</Link>
                </li>
                     
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default Electricity; 